export interface IssueMarkdownInput {
  callLogId: string;
  roomName?: string | null;
  organizationId?: string | null;
  assistantName?: string | null;
  callDate?: string | null;
  langfuseUrl?: string | null;
  question: string;
  answer: string;
}

// First line of the answer's Verdict, used as the issue title.
function titleFrom(answer: string, question: string): string {
  const verdict = answer.match(/##\s*Verdict\s*\n+([^\n]+)/i)?.[1];
  const raw = (verdict || question).replace(/[*_`#>]/g, "").trim();
  return raw.length > 90 ? `${raw.slice(0, 87)}...` : raw;
}

export function buildIssueMarkdown(input: IssueMarkdownInput): string {
  const lines = [
    `# ${titleFrom(input.answer, input.question) || "Call diagnosis"}`,
    "",
    `- Call ID: \`${input.callLogId}\``,
    `- Room: ${input.roomName ? `\`${input.roomName}\`` : "n/a"}`,
    `- Organization ID: ${input.organizationId ? `\`${input.organizationId}\`` : "n/a"}`,
    `- Assistant: ${input.assistantName || "n/a"}`,
    `- Call date: ${input.callDate || "n/a"}`,
    `- Langfuse: ${input.langfuseUrl || "n/a"}`,
    "",
    "## Question",
    "",
    input.question.trim(),
    "",
    "## Diagnosis",
    "",
    input.answer.trim(),
    "",
    "---",
    "Diagnosed by Claude Sonnet 5.5 via Voxi dashboard",
    "",
  ];
  return lines.join("\n");
}
